import React from 'react';
import Icon from '../../../components/AppIcon';

const TeamStats = ({ members }) => {
  const totalMembers = members?.length;
  const activeMembers = members?.filter(m => m?.status === 'Active')?.length;
  const pendingInvites = members?.filter(m => m?.status === 'Pending')?.length;
  const roleDistribution = members?.reduce((acc, member) => {
    acc[member.role] = (acc?.[member?.role] || 0) + 1;
    return acc;
  }, {});

  const stats = [
    {
      label: 'Total Members',
      value: totalMembers,
      icon: 'Users',
      color: 'text-foreground',
      bgColor: 'bg-muted/50'
    },
    {
      label: 'Active Members',
      value: activeMembers,
      icon: 'UserCheck',
      color: 'text-success',
      bgColor: 'bg-success/10'
    },
    {
      label: 'Pending Invites',
      value: pendingInvites,
      icon: 'UserPlus',
      color: 'text-warning',
      bgColor: 'bg-warning/10'
    },
    {
      label: 'Designers',
      value: roleDistribution?.Designer || 0,
      icon: 'Palette',
      color: 'text-blue-600',
      bgColor: 'bg-blue-50'
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      {stats?.map((stat, index) => (
        <div key={index} className="bg-card border border-border rounded-lg p-4 elevation-1">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-muted-foreground">{stat?.label}</p>
              <p className="text-2xl font-heading text-foreground mt-1">{stat?.value}</p>
            </div>
            <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${stat?.bgColor}`}>
              <Icon name={stat?.icon} size={20} color={`var(--color-${stat?.color?.replace('text-', '')})`} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default TeamStats;